import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {ProductRecommendationService} from "../../providers/product-recommendation.service";
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {PartnerProductService} from "../../providers/partner-product.service";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Subscription} from "rxjs";
import {ProductCategoriesForSpecies} from "../../models/product-categories-for-species.model";
import {ProductCategory} from "../../models/product-category.model";
import {VetClinic} from "../../models/vet-clinic.model";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {Client} from "../../models/client.model";



@Component({
  selector: 'app-product-recommendation-configurator',
  templateUrl: './product-recommendation-configurator.component.html',
  styleUrls: ['./product-recommendation-configurator.component.scss'],
})
export class ProductRecommendationConfiguratorComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Output() actionSubmitEmitter = new EventEmitter<boolean>();
  subscriptions: Subscription = new Subscription();
  categories: ProductCategoriesForSpecies[];
  isGeneralClientAdmin: boolean = true;
  isGeneralAdmin: boolean = true;
  isAdmin: boolean = true;
  segment: 'dog' | 'cat' = 'dog';
  currentCategories: ProductCategory[];
  configuredCategories: ProductCategoriesForSpecies[];
  vetcode: number;
  clinics: VetClinic[];
  selectOptions: any = {
    header: 'Wybierz lecznicę'
  };
  clinicSelected: VetClinic;
  clientSelected: Client;
  private clinicUUID: string;


  constructor(private productRecommendationService: ProductRecommendationService,
              private modalController: ModalController,
              protected commonUtils: CommonUtils,
              private appStateService: AppStateService,
              private partnerProductService: PartnerProductService,
              private translateService: TranslateService,
              private vetClinicService: VetClinicService) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  async ngOnInit() {
    this.registerSubscription(this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    }));

    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralClientAdmin = this.user.vClientId !== null && this.user.vetcodeId === null;
    this.isGeneralAdmin = this.user.vClientId === null && this.user.vetcodeId === null;



    if (this.isGeneralClientAdmin) {
      this.appStateService.updateIsBusySubject(true);
      this.registerSubscription(this.vetClinicService.listClinicsForClient(this.user.vClientUUID).subscribe(async e => {
        if (e) {
          this.clinics = e;
          if (this.clinics.length === 1) {
            this.clinicSelected = this.clinics[0];
            this.onSelectVetcode(this.clinicSelected.vetcodeId);
          }
          this.appStateService.updateIsBusySubject(false);
        } else {
          this.appStateService.updateIsBusySubject(false);
          this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
        }
      }));
    }


    if (this.user.vetcodeId) {
      this.vetcode = Number.parseInt(this.user.vetcodeId);
    }

    try {
      this.appStateService.updateIsBusySubject(true);
      this.categories = await this.partnerProductService.getCategories().toPromise();
      if (this.categories && this.vetcode) {
        try {
          let tmpJsonCat = await this.partnerProductService.getCategoriesConfig(this.vetcode).toPromise();
          if (tmpJsonCat) {
            this.configuredCategories = JSON.parse(tmpJsonCat);
          }

          if (this.configuredCategories) {
            this.preselectAlreadyConfiguredCategories();
          }
        } catch (e) {

        }

        this.appStateService.updateIsBusySubject(false);
        this.updateCurrentCategories();
      }
      this.appStateService.updateIsBusySubject(false);
    } catch (e) {
      this.appStateService.updateIsBusySubject(false);
    }

    super.ngOnInit();
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  onAction(): void {
  }

  async onSubmit() {
    const categoryBackup: ProductCategoriesForSpecies[] = [];

    for (const speciesCategory of this.categories) {
      categoryBackup.push({...speciesCategory});
      speciesCategory.categories = speciesCategory.categories.filter(category => category.selected);
      for (const category of speciesCategory.categories) {
        category.categories = category.categories.filter(innerCategory => innerCategory.selected);
      }
    }
    this.clinicUUID = this.clinicSelected.uuid;

    if (!this.clinicUUID) {
      this.commonUtils.presentAlertToast('Brak wybranej lecznicy');
      return;
    }

    this.appStateService.updateIsBusySubject(true);
    this.partnerProductService.configureCategories(this.clinicUUID, JSON.stringify(this.categories)).subscribe(response => {
      if (response === true) {
        this.commonUtils.presentInfoToast('Konfiguracja kategorii zakończona sukcesem');
        this.appStateService.updateIsBusySubject(false);
        this.actionSubmitEmitter.emit(true);
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisu konfiguracji. Proszę spróbować później');
        this.appStateService.updateIsBusySubject(false);
        this.categories = categoryBackup;
      }
    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisu konfiguracji. Proszę spróbować później');
      this.appStateService.updateIsBusySubject(false);
      this.categories = categoryBackup;
    });

  }

  onSegmentChange($event: any) {
    this.segment = $event.detail.value;
    this.updateCurrentCategories();
  }

  updateCurrentCategories() {
    this.currentCategories = this.categories.find(
      value => value.species.toUpperCase() === this.segment.toUpperCase()
    )?.categories.sort((a, b) => a.order - b.order) ?? [];
  }

  getCategoryStarIconName(category: ProductCategory) {

    if (category.selected) {
      return 'star';
    }
    return 'star-outline';

  }

  onSelectCategory(category: ProductCategory) {
    category.selected = !category.selected;
    if (category.categories) {
      for (const inner of category.categories) {
        inner.selected = category.selected;
      }
    }
  }

  onSelectInnerCategory(innerCategory: ProductCategory, category: ProductCategory, preselect: boolean = false) {
    if (preselect) {
      innerCategory.selected = false;
    }
    innerCategory.selected = !innerCategory.selected;
    let anySelected = false;
    for (const inner of category.categories) {
      if (inner.selected) {
        anySelected = true;
      }
    }
    category.selected = anySelected;

  }

  clearSelectedCategories() {

    for (const speciesCategory of this.categories) {
      for (const category of speciesCategory.categories) {
        category.selected = false;
        for (const innerCategory of category.categories) {
          innerCategory.selected = false;
        }
      }
    }
  }

  preselectAlreadyConfiguredCategories() {
    const categoryMap = new Map<string, any>();

    for (const speciesCategory of this.categories) {
      for (const category of speciesCategory.categories) {
        for (const innerCategory of category.categories) {
          categoryMap.set(`${speciesCategory.species}-${category.name}-${innerCategory.name}`, {
            innerCategory,
            category
          });
        }
      }
    }

    for (const speciesCategory of this.configuredCategories) {
      for (const category of speciesCategory.categories) {
        for (const innerCategory of category.categories) {
          const key = `${speciesCategory.species}-${category.name}-${innerCategory.name}`;
          const match = categoryMap.get(key);
          if (match) {
            this.onSelectInnerCategory(match.innerCategory, match.category, true);
          }
        }
      }
    }
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clinicSelected = null;
        this.vetcode = null;
        this.clientSelected = data.data;
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.vetClinicService.listClinicsForClient(this.clientSelected.uuid).subscribe(e => {
          if (e) {
            this.clinics = e;
            if (this.clinics.length === 1) {
              this.clinicSelected = this.clinics[0];
            }
            this.appStateService.updateIsBusySubject(false);
          } else {
            this.appStateService.updateIsBusySubject(false);
            this.commonUtils.presentAlertToast('Nie znaleziono lecznic dla podanego klienta');
          }
        }));
      }
    });

    return await modal.present();
  }

  async onSelectVetcode(vetcode: number) {
    this.vetcode = vetcode;
    this.appStateService.updateIsBusySubject(true);
    let tmpJsonCat = await this.partnerProductService.getCategoriesConfig(this.vetcode).toPromise();
    if (tmpJsonCat) {
      this.configuredCategories = JSON.parse(tmpJsonCat);
    }
    if (this.configuredCategories) {
      this.clearSelectedCategories();
      this.preselectAlreadyConfiguredCategories();
    }
    this.appStateService.updateIsBusySubject(false);
    this.updateCurrentCategories();

  }


  getSelectedText() {
    if (this.clinicSelected && this.clinics && this.clinics.length > 1) {
      const sameNameClinicExists = this.clinics.some(c => this.clinicSelected.clinicName === c.clinicName);
      if (sameNameClinicExists) {
        return this.commonUtils.getClinicNameWithAddress(this.clinicSelected);
      }
    }
    if (this.clinicSelected) {
      return this.clinicSelected.clinicName;
    } else {
      return '';
    }
  }

  onSelectClinic($event: any) {
    if ($event.detail.value) {
      this.onSelectVetcode($event.detail.value.vetcodeId);
    }
  }

}
